import { supabase } from '@/lib/supabase';

export type DbColumn = {
  table: string;
  name: string;
  type: string;
  udtName: string;
  isNullable: boolean;
  default: string | null;
  ordinal: number;
};

export type DbForeignKey = {
  constraintName: string;
  sourceTable: string;
  sourceColumn: string;
  targetTable: string;
  targetColumn: string;
};

export type DbSchema = {
  tables: Array<{ name: string }>;
  columns: DbColumn[];
  foreignKeys: DbForeignKey[];
};

const dbSchemaService = {
  async getSchema(): Promise<DbSchema> {
    const { data, error } = await supabase.rpc('get_db_schema');
    if (error) throw error;

    return {
      tables: data?.tables ?? [],
      columns: data?.columns ?? [],
      foreignKeys: data?.foreignKeys ?? [],
    };
  },
};

export default dbSchemaService;
